<template>
    <div class="page">
        <div class="logo">
            <img src="@/assets/userNew/aicon11.png" alt="">
        </div>
        <div class="form">
            <van-field v-model="iccid" name="mobile" label="号码" placeholder="请输入你要激活的号码"
                :rules="[{ required: true, message: '请输入你要激活的号码' }]" />
            <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit">登录</van-button>
            <van-button class="bu_tn1" round plain block type="info" native-type="submit"
                @click="toActiveTv">激活视频</van-button>
            <!-- <van-button class="bu_tn2" round block type="info" native-type="submit" @click="toKefu">联系客服</van-button> -->
        </div>
        <!-- <div class="zxkf" style="" @click="toKefu">
            <img src="@/assets/userNew/icon3.png" style="width:22px;height: 22px;margin-top:4px;">
            <div class="zxkf-btn">联系客服</div>
        </div> -->
        <div class="prompt" :style="{ 'margin-top': height + 'px' }">
            <div class="prompt-top">温馨提示</div>
            <div class="prompt-name">请在收到卡后尽快开通，以免优惠失效</div>
            <div class="prompt-name">开通成功后，套餐长期有效，不使用不扣费</div>
            <div class="prompt-name">开通成功后再次登录，会直接进入卡管理系统</div>
        </div>

    </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js'
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
    components: { SeAutocomplete, Advertisement },
    data() {
        return {
            isDialogShow: false,
            phoneList: '',


            iccid: '',
            code: '',
            showAds: true,
            gzh: '',
            height: null,
            realNameList: ['1192351241053663232', '1224969664338063360', '1255666672321163264', '7DA692EC992B45E297450F40DEDC5614', '8601954A2B074E80AACAAF32C5EE232C',
                '960F3276EFAA4ED2999754895F4BCCB4', 'B1E112B9F1D8420E9072D9F47D6A135E', '1275705014286807040',
                '1275706083402313728', '1274979554988912640', '1279289937396494336'],
            suolangList: ['1275704520822747136']
        }
    },
    methods: {
        toKefu() {
            if (this.$route.query.iccid) {
                wxRequest("sim/get/kefu/url", { iccid: this.$route.query.iccid }, "post").then(
                    (res) => {
                        if (res.data.code == 200) {
                            window.location.href = res.data.data;
                        } else {
                            window.location.href = 'https://work.weixin.qq.com/kfid/kfceda7e24c02e32677';
                        }
                    }
                );

            } else {
                window.location.href = 'https://work.weixin.qq.com/kfid/kfceda7e24c02e32677';
            }
        },
        selectIon(item, index) {
            this.inx = index
            this.iccid = item.cardNo
        },


        toActiveTv() {
            window.location.href = 'http://app.iot688.cn/mv.mp4';
        },
        toTouSu() {
            this.$router.push({
                path: "/user/entrance",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;
            cb(results);
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item) {
            this.iccid = item
        },
        onSubmit() {
            let recordLoginText = this.iccid;
            let data = {
                requestId: this.iccid,
                code: this.code,
            };
            wxRequest("sim/bind", data, "get").then((res) => {
                if (res.data.code == 200) {
                    let record = res.data.data;
                    let iccid = record.iccid;

                    this.$store.state.isNewPage = 6;
                    localStorage.setItem("isNewPage", 6);

                    localStorage.setItem("bindPhone", record.bindPhone);
                    localStorage.setItem("titleUrl", record.titleUrl);
                    localStorage.setItem("titleImg", record.titleImg);
                    localStorage.setItem("isTitle", record.isTitle);


                    localStorage.setItem("isCode", true);
                    localStorage.setItem("mobile", record.mobile);
                    localStorage.setItem("supplierTypeName", record.supplierTypeName);
                    localStorage.setItem("wxHeadImg", record.wxHeadImg);
                    localStorage.setItem("wxNickName", record.wxNickName);
                    localStorage.setItem("shebeiLogin", 0);
                    localStorage.setItem("recordLoginText", recordLoginText);
                    localStorage.setItem("supplierName", record.supplierName);
                    localStorage.setItem("intoNo", record.intoNo);
                    localStorage.setItem("isSale", record.isSale);
                    localStorage.setItem("yucun", record.yucun);
                    localStorage.setItem("kefuUrl", record.kefuUrl);
                    localStorage.setItem("priceImgUrl", record.priceImgUrl);
                    localStorage.setItem("ishavePkg", record.ishavePkg);
                    localStorage.setItem("isSale", record.isSale);
                    localStorage.setItem("salePrice", record.salePrice);
                    localStorage.setItem("ishavePrice", record.ishavePrice);
                    sessionStorage.setItem("isLine", true);
                    localStorage.setItem("flowRatePool", record.flowRatePool);
                    this.$store.state.flowRatePool = res.data.data.flowRatePool;
                    localStorage.setItem("iccid", record.iccid);
                    localStorage.setItem("openId", record.openId);
                    localStorage.setItem("virtualNo", record.virtualNo);

                    localStorage.setItem("userPhone", record.userPhone);
                    this.$store.state.userPhone = record.userPhone;

                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;
                    this.$store.state.iccid = iccid;
                    this.$store.commit("setIccid", iccid);

                    this.$store.state.intoNo = record.intoNo;
                    sessionStorage.setItem("intoNo", record.intoNo);
                    //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    if (record.bindPhone == 2) {
                        this.$router.push({
                            path: "/userNew/bindPhone",
                            query: {
                                iccid: record.iccid,
                            },
                        });
                    } else if ((record.isSale == 1 || record.isSale == 3) && record.ishavePrice == 0) {
                        this.$router.replace("/user/simOpens");
                    } else if (record.isSale > 0 && record.ishavePrice == 0) {
                        this.$router.replace("/user/simOpens");
                    } else {
                        localStorage.setItem("phoneNo", record.userPhone);
                        this.$router.replace("/userNew/home");
                    }
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            });
        },





        //获取url参数
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return false;
        },
    },
    async created() {
        var source = this.getQueryVariable("source")
            ? this.getQueryVariable("source")
            : process.env.VUE_APP_APPID;
        localStorage.setItem("isHeadquarterAppid", true);
        var appid = source ? source : process.env.VUE_APP_APPID;
        //获取总部公众号appid
        await wxRequest("/sim/appId", {}, "post").then((res) => {
            if (res.data.code == 200) {
                appid = res.data.data.collectAppid;
            }
        });
        this.$store.commit("setIsHeadquarterAppid", "true");
        localStorage.setItem("isHeadquarterAppid", true);
        localStorage.setItem("appid", source);
        console.log(appid);

        //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
        await wxRequest(
            "sim/get/pay/state",
            {
                iccid: localStorage.getItem("iccid"),
            },
            "post"
        ).then((res) => {
            localStorage.setItem("payCode", res.data.code);
            if (res.data.code == 200) {
                localStorage.setItem("leshuaPay", 1);
                this.code = "leshua";
                this.iccid = localStorage.getItem("recordLoginText");
            } else {
                var redirectUrl = window.location.href;
                var index = redirectUrl.indexOf("code");
                redirectUrl = encodeURIComponent(redirectUrl);
                localStorage.setItem("leshuaPay", 2);
                if (index < 0) {
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
                } else {
                    var search = window.location.search;
                    console.log("search", search);
                    var startIndex = search.indexOf("code");
                    var endIndex = search.indexOf("&", startIndex);
                    var str = search.slice(startIndex, endIndex);
                    var code = str.slice(str.indexOf("=") + 1);
                    this.code = code;
                    this.iccid = localStorage.getItem("recordLoginText");
                }
            }
        });
    },

    mounted() {
        this.height = document.documentElement.clientHeight - 610
    },


    beforeDestory() {

    }
}
</script>

<style scoped lang="less">
.more-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10001;

    .more-bg {
        background: rgba(0, 0, 0, .3);
        width: 100%;
        height: 100%;
    }

    .more-list {
        width: 90%;
        height: 400px;
        background: #fff;
        border-radius: 10px;
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        bottom: 0;
        right: 0;

        .more-title {
            text-align: center;
            font-size: 19px;
            border-radius: 14px;
            font-weight: 600;
            color: #222222;
            height: 51px;
            padding-top: 22px;
            background: linear-gradient(180deg, #DAE8FF 0%, rgba(255, 255, 255, 0) 100%);
        }

        .more-list-flex {
            overflow: auto;
            height: 220px;
        }

        .more-list-item {
            display: flex;
            height: 60px;
            width: 85%;
            margin: 0 auto 8px;
            border: 1px solid #EEF4FF;
            align-items: center;

            img {
                width: 65px;
                height: 18px;
                margin-left: 10px;
                margin-right: 20px;
            }

            .num {
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #94959A;
                line-height: 20px;
            }
        }

        .active {
            border: 1px solid #1772FF;
        }

        .dialog-btn {
            display: flex;
            position: absolute;
            bottom: 18px;
            width: 100%;
            height: 40px;
            justify-content: space-around;

            .close {
                width: 121px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 7px;
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                text-align: center;
                line-height: 44px;
            }

            .corm {
                width: 121px;
                height: 44px;
                background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
                border-radius: 7px;
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #fff;
                text-align: center;
                line-height: 44px;
            }
        }
    }

}

.page {
    background: #F7F8FA url('../../assets/userNew/icon4.png') no-repeat top center;
    background-size: 100%;
    height: 100vh;
    position: relative;

    .logo {
        width: 237px;
        height: 150px;
        display: block;
        margin: 0 auto 10px;
        padding-top: 25px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .form {
        width: 80%;
        padding: 12px 16px;
        margin: auto;

        .van-cell {
            height: 50px;
            width: 100%;
            border-radius: 30px;
            padding-left: 10px;
            padding: 0;
            background: #fff;
            margin: auto;
            text-align: center;
            margin-top: 20px;
            line-height: 48px;

            ::v-deep .van-cell__value {
                line-height: 48px;

                .van-field__body {
                    .van-field__control {
                        line-height: 48px;
                        height: 48px;
                        text-align: left;
                    }
                }
            }
        }

        .bu_tn {
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            font-size: 18px;
            background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
            border-radius: 30px;
            margin: auto;
            margin-top: 20px;
        }

        .bu_tn2 {
            width: 60%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            font-size: 18px;
            background: #f7761b;
            border-radius: 30px;
            margin: auto;
            margin-top: 20px;
            border: 1px solid #f7761b;
        }

        .bu_tn1 {
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #409FFD;
            background: #fff;
            border-radius: 30px;
            width: 60%;
            margin: auto;
            font-size: 16px;
            margin-top: 20px;
            border: 1px solid #207BFF;
        }
    }

    .zxkf {
        width: 40px;
        height: 100px;
        position: fixed;
        border-radius: 25px;
        right: 6px;
        bottom: 200px;
        text-align: center;
        background: #EAF2FF;

        .zxkf-btn {
            font-size: 14px;
            color: #397EF5;
            line-height: 15px;
            margin: 0 8px;
            margin-top: 6px;
        }
    }

    .prompt {
        padding: 18px;
        width: 80%;
        background: #fff;
        border-radius: 10px;
        margin: auto;

        .prompt-top {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 20px;
            padding-left: 22px;
            background: url('../../assets/userNew/icon2.png') no-repeat left center;
            background-size: 17px 12px;
        }

        .prompt-name {
            color: #646668;
            font-size: 12px;
            line-height: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
        }
    }
}
</style>